import React, { useEffect } from 'react';

// Mobile bottom sheet (filters, action menus). Only rendered on compact
// viewports — desktop keeps its existing inline toolbars and popovers.
export default function BottomSheet({ open, onClose, title, children, footer }) {
  useEffect(() => {
    if (!open) return undefined;
    function onKey(e) { if (e.key === 'Escape') onClose?.(); }
    window.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div style={st.overlay} onClick={onClose}>
      <div style={st.sheet} onClick={e => e.stopPropagation()} role="dialog" aria-modal="true" aria-label={title}>
        <div style={st.handle} />
        <div style={st.header}>
          <h3 style={st.title}>{title}</h3>
          <button type="button" style={st.close} onClick={onClose} aria-label="Cerrar">✕</button>
        </div>
        <div style={st.body}>{children}</div>
        {footer && <div style={st.footer}>{footer}</div>}
      </div>
    </div>
  );
}

const WINE = '#6B1C2A';

const st = {
  overlay: {
    position: 'fixed', inset: 0, zIndex: 10050,
    background: 'rgba(20,16,18,0.45)',
    display: 'flex', alignItems: 'flex-end',
  },
  sheet: {
    width: '100%', maxHeight: '85vh', overflowY: 'auto',
    background: '#FDFBF8', borderRadius: '16px 16px 0 0',
    boxShadow: '0 -10px 30px rgba(0,0,0,0.2)',
    fontFamily: "'DM Sans',sans-serif",
    paddingBottom: 'env(safe-area-inset-bottom)',
  },
  handle: { width: 40, height: 4, borderRadius: 2, background: '#D8CFC4', margin: '10px auto 0' },
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '6px 8px 4px 16px', position: 'sticky', top: 0, background: '#FDFBF8', zIndex: 1,
  },
  title: { fontFamily: "'Cormorant Garamond', serif", fontSize: 22, fontWeight: 600, color: WINE, margin: 0 },
  close: {
    width: 44, height: 44, border: 'none', background: 'transparent',
    fontSize: 18, color: 'var(--text-secondary)', cursor: 'pointer',
  },
  body: { display: 'flex', flexDirection: 'column', gap: 10, padding: '6px 16px 16px' },
  footer: {
    display: 'flex', gap: 8, padding: '12px 16px 16px',
    borderTop: '1px solid #f0ebe3', position: 'sticky', bottom: 0, background: '#FDFBF8',
  },
};
